import React, { useEffect } from 'react'
import MobileCategoryDrawer from './MobileCategoryDrawer';
import { defaultProductImage, NavLink, useSelector } from "../../../imports/generalImport";
import { Box, Stack, Typography, useMediaQuery, useTheme } from "../../../imports/muiImport";
import { categoryUrl } from '../../../shared/extra';
import MobileLoading from '../mobileLoading/MobileLoading';
import MobileSectionTitle from '../mobileProductCard/MobileSectionTitle';

export default function MobileHomeCategory() {
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    const categoryData = useSelector((state) => state?.MobileHomepage?.allData?.categories);

    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const visibleCategoryCount = isMobile ? 8 : 12;


    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen);
    };

    const customBtnHandler = () => {
        setOpen(!open);
    }

    return (
        <>
            <MobileCategoryDrawer open={open} setOpen={setOpen} toggleDrawer={toggleDrawer} />
            <Box sx={{
                p: 2,
            }}>
                <Box sx={{
                }}>

                    <Stack
                        sx={{
                            mb: 2,
                        }}
                    >
                        <MobileSectionTitle
                            sectionTitle={"categories"}
                            buttonText={"view all"}
                            customBtnHandler={customBtnHandler}
                        />
                    </Stack>

                    {!categoryData?.length ?
                        (
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    minHeight: 240
                                }}>
                                <MobileLoading />
                            </Box>
                        )
                        :
                        (
                            <Box sx={{
                                display: "grid",
                                gridTemplateRows: "2,1fr",
                                gridTemplateColumns: {
                                    xs: "repeat(4,1fr)",
                                    sm: "repeat(6,1fr)"
                                },
                                rowGap: 2.5,
                                columnGap: 1.5,
                                overflow: 'hidden',
                            }}>
                                {categoryData
                                    ?.filter((item) => item?.products?.length > 0)
                                    ?.slice(0, visibleCategoryCount)
                                    ?.map((item) => {
                                        if (item?.products?.length > 0) {
                                            return (
                                                <NavLink
                                                    to={`card-list?category=${categoryUrl(item?.title)}`}
                                                    key={`category-${item?.id * 1}`}
                                                    style={{
                                                        textDecoration: "none",
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                        }}>
                                                        <Box
                                                            component="img"
                                                            src={item?.image || defaultProductImage}
                                                            width={60}
                                                            height={60}
                                                            sx={{
                                                                // borderRadius: "50%",
                                                                objectFit: "cover",
                                                                // p: "4px",
                                                                // border: "1px solid #deebff",
                                                            }}
                                                        />

                                                        <Typography variant='subtitle1' sx={{
                                                            width: "100%",
                                                            textAlign: "center",
                                                            color: "primary.main",
                                                            fontWeight: 400,
                                                            fontSize: "11.5px",
                                                            textDecoration: "none",
                                                        }}>
                                                            {item?.title}
                                                        </Typography>
                                                    </Box>
                                                </NavLink>
                                            );
                                        }
                                        else {
                                            return null;
                                        }
                                    })}

                            </Box>
                        )
                    }
                </Box>

            </Box>

        </>
    )
}